import hero_arena from "../../assets/img/heroes/arena.png";
import hero_cs from "../../assets/img/heroes/cs.png";
import hero_valorant from "../../assets/img/heroes/valorant.png";
import hero_lol from "../../assets/img/heroes/lol.png";
import hero_chess from "../../assets/img/heroes/chess.png";
import hero_entertainment from "../../assets/img/heroes/entertainment.png";
import hero_rocket_league from "../../assets/img/heroes/rocket_league.png";

const mainCarouselContent = [
  {
    title: "Arena Games",
    description:
      "É com muita energia que damos as boas-vindas a todos os participantes e visitantes da Arena Games, um evento organizado pelo curso de Ciência da Computação do IFSUL – Campus Passo Fundo. Aqui você encontrará todas as informações sobre o cronograma de atividades, datas, inscrições e os jogos disponíveis no campeonato. Prepare-se para competir, se divertir e compartilhar momentos incríveis com outros apaixonados por games.",
    image: hero_arena,
  },
  {
    title: "Counter Strike",
    description:
      "Participe de confrontos intensos que exigem estratégia, comunicação e precisão. Forme sua equipe e dispute partidas eletrizantes do início ao fim.",
    image: hero_cs,
  },
  {
    title: "League of Legends",
    description:
      "Entre no campo de batalha e mostre seu domínio tático em partidas dinâmicas. Coordenação em equipe e tomada de decisão serão essenciais para a vitória.",
    image: hero_lol,
  },
  {
    title: "Valorant",
    description:
      "Combine habilidade mecânica e estratégia em um ambiente competitivo. Utilize agentes, habilidades e trabalho em equipe para superar seus adversários.",
    image: hero_valorant,
  },
  {
    title: "Rocket League",
    description:
      "Acelere rumo à vitória em partidas intensas que misturam futebol e alta velocidade. Execute manobras aéreas, faça jogadas espetaculares e supere seus adversários em confrontos cheios de adrenalina.",
    image: hero_rocket_league,
  },
  {
    title: "Xadrez",
    description:
      "Teste seu raciocínio lógico e capacidade estratégica em partidas que valorizam planejamento e concentração a cada movimento.",
    image: hero_chess,
  },
  {
    title: "Entretenimento",
    description:
      "Prepare-se para muita diversão no campus, com mesas de RPG, jogos retrô, jogos de cartas e várias outras atividades imperdíveis.",
    image: hero_entertainment,
  },
];

export default mainCarouselContent;
